export const APP_STORE_URL =
    'https://apps.apple.com/cn/app/%E9%A3%9F%E5%85%89%E6%9C%BA-ai%E9%A5%AE%E9%A3%9F%E5%8D%A1%E8%B7%AF%E9%87%8C%E8%AE%B0%E5%BD%95/id6756870540?l=en-GB';
